import { action, makeObservable, observable } from 'mobx'
import { greaterThanOrEqual } from 'utils/validation-utils'
import { required, validationContext } from 'validx'

/**
 * View Model for Bundle Price.
 */
export class PriceEditorViewModel {
  /**
   * The client amount for the Bundle. This is the amount the client will
   * be charged.
   */
  @observable price = 0

  /**
   * Validation context.
   */
  validation = validationContext(this, {
    price: [
      required('A bundle price is required.'),
      greaterThanOrEqual(0, 'The amount must be zero or greater.'),
    ],
  })

  constructor() {
    makeObservable(this)
  }

  /**
   * @inheritdoc
   */
  validate(): boolean {
    return this.validation.reset().validate().isValid
  }

  /**
   * @inheritdoc
   */
  @action.bound
  hydrate(price: number): void {
    this.price = price
  }

  /**
   * @inheritdoc
   */
  toValue(): number {
    return this.price
  }

  /**
   * @inheritdoc
   */
  @action.bound
  reset() {
    this.price = 0
    this.validation.reset()
  }
}
